<div class="approval-list" id="body-content">
  <header class="approval-list__header">
    <img class="logo" src="/assets/svg/logo_fibra.svg" alt="Logo Fibra" />
    <p class="tagline">
      Operações de crédito - Internet Banking - Banco Fibra -
      {{ this.date }} - Auto atendimento IB - {{ this.hour }}.
    </p>
    <h3 class="headline">Cheque Empresa</h3>
  </header>
  <main class="approval-list__content">

    <div class="approval-list__content__table">
      <table class="approval-table">
        <tr>
          <th class="tbl-col-1">Conta</th>
          <th class="tbl-col-2">Limite cheque empresa</th>
          <th class="tbl-col-3">Data de contratação</th>
          <th class="tbl-col-4">Taxa de juros(%a.m.)</th>
          <th class="tbl-col-5">Carência</th>
        </tr>

        <tr *ngFor="let item of loansList">
          <td>{{ item.nro_conta }}</td>
          <td>{{ item.valor_limite | currency: 'BRL' }}</td>
          <td>
            <p class="tipo-transacao">{{ item.dt_contratacao | date: 'dd/MM/yyyy' }}</p>
           
          </td>
          <td>{{ item.taxa_juros_mes }}</td>
          <td>{{ item.num_dias_carencia }}</td>  
        </tr>
      </table>
    </div>
  </main>
</div>


